module.exports = __webpack_public_path__ + "img/bornutti25.d23db9fa.jpg";